import { Delete, Edit, TramSharp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage';

export const PrioridadComponent = ({prioridad}) => {
  const {modalAgregaPrioridad, setModalAgregaPrioridad,obtenerPrioridades,modalEliminarPrioridad, setModalEliminarPrioridad, prioridadSel, setPrioridadSel} = useContext(PrioridadesContext);

  return (
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        marginTop:6,
        backgroundColor:'white',
        borderRadius:10,
        padding:5,
        alignItems:'center'
      }}
    >
      <div
        style={{
          fontSize:14,
          
        }}
      >
        {prioridad.Prioridad}
      </div>
      <div>
        <IconButton
          onClick={() => {
            setPrioridadSel(prioridad)
            setModalAgregaPrioridad(true);
          }}
        >
        <Edit style={{color:'green'}} />
        </IconButton>
        <IconButton
          onClick={() => {
            setModalEliminarPrioridad(true);
            setPrioridadSel(prioridad)
          }}
        >
          <Delete style={{color:'red'}} />
        </IconButton>
      </div>
    </div>
  )
}
